import { iDeviceDetails, iFullStoreState } from "../../../shared/interfaces";
import { Map } from "immutable";

export const selectDevices = (s: iFullStoreState): Map<string, iDeviceDetails> => s.devicesData.devicesDetails;